import { capitalizeWordsInSentence, getStateName } from '@dill/dill-shared/dist/src';

const mideskData = [
  {
    addresses: [
      {
        is_registered_agent: false,
        sources: [],
        city: 'New York',
        latitude: 40.52,
        street_view_available: false,
        rating: {
          risk_rating: 'low',
          indicators: [
            {
              name: 'Valid US address',
              rating: 'positive',
              description: 'Valid',
              type: 'valid_us_address',
              value: 'valid',
            },
            {
              name: 'Deliverability',
              rating: 'positive',
              description: 'Deliverable',
              type: 'deliverability',
              value: 'deliverable',
            },
            {
              name: 'Geographical location',
              rating: 'positive',
              description: 'US',
              type: 'geographical_location',
              value: 'us',
            },
            {
              name: 'Commercial registered agent',
              rating: 'positive',
              description: 'Not a commercial registered agent',
              type: 'registered_agent',
              value: 'not_registered_agent',
            },
            {
              name: 'Private mailbox',
              rating: 'positive',
              description: 'Not a private mailbox',
              type: 'private_mailbox',
              value: 'not_private_mailbox',
            },
            {
              name: 'Location frequency',
              rating: 'positive',
              description: '1 business',
              type: 'location_frequency',
              value: '1_business',
            },
            {
              name: 'Virtual address',
              rating: 'positive',
              description: 'Not a virtual address',
              type: 'virtual_address',
              value: 'not_virtual_address',
            },
          ],
        },
        deliverable: true,
        created_at: '2026-02-20T17:07:33.482Z',
        full_address: '123 Grand St., New York, NY 10013',
        address_line2: null,
        updated_at: '2026-02-20T17:07:33.720Z',
        address_line1: '123 Grand St',
        property_type: null,
        state: 'NY',
        id: 'cb837b02-eb55-4bf3-a7bd-188d4b624cef',
        longitude: 30.4,
        location_count: 1,
        deliverability_analysis: null,
        registered_agent_name: null,
        labels: [],
        submitted: true,
        cmra: false,
        postal_code: '10013',
        business_id: '5f9d0d33-88bf-405b-a3f6-ec4b52f4230e',
        object: 'address',
      },
    ],
    documents: [],
    fmcsa_registrations: [],
    adverse_media_screening: null,
    created_at: '2026-02-20T17:07:33.471Z',
    external_id: null,
    formation: null,
    subscription: null,
    industry_classification: null,
    updated_at: '2026-02-20T17:07:34.570Z',
    bankruptcies: [],
    review: {
      completed_at: null,
      updated_at: '2026-02-20T17:07:33.631Z',
      created_at: '2026-02-20T17:07:33.631Z',
      id: 'e9a6cfe4-eba2-40f6-9131-edf4b87ce1fb',
      assignee: {
        settings: {
          receives_agent_emails: false,
        },
        last_login_at: null,
        directory_managed: false,
        image_url:
          'https://www.gravatar.com/avatar/bd43e7168c81bb7fe5b439c8582d59e0?s=64&d=https%3A%2F%2Fapp-sandbox.middesk.com%2Fimages%2Fdefault-avatar.png',
        roles: ['admin', 'member'],
        name: 'Catherine Jiang',
        created_at: '2026-02-17T21:26:07.880Z',
        id: '43b518e0-8921-49c9-b94a-40dcd649020b',
        email: 'catherine@usedill.com',
        object: 'user',
      },
      tasks: [
        {
          sub_label: 'Alternate Name',
          sources: [],
          name: 'name',
          label: 'Business Name',
          category: 'name',
          message: 'We believe the submitted TIN is associated with "MATCHING INC"',
          key: 'name',
          status: 'failure',
        },
        {
          sub_label: 'Unverified',
          sources: [],
          name: 'address',
          label: 'Office Address',
          category: 'address',
          message: 'Unable to identify a match to the submitted Office Address',
          key: 'address_verification',
          status: 'failure',
        },
        {
          sub_label: 'Submitted Not Registered',
          sources: [],
          name: 'sos',
          label: 'SOS Filings',
          category: 'sos',
          message: 'The business is not registered in the state of the submitted Office Address',
          key: 'sos_match',
          status: 'failure',
        },
        {
          sub_label: 'Not Registered',
          sources: [],
          name: 'sos',
          label: 'SOS Filings',
          category: 'sos',
          message: 'The business has no Secretary of State filings',
          key: 'sos_not_found',
          status: 'failure',
        },
        {
          sub_label: 'Mismatch',
          sources: [],
          name: 'tin',
          label: 'TIN Match',
          category: 'tin',
          message: 'We believe the submitted TIN is associated with a different Business Name',
          key: 'tin',
          status: 'failure',
        },
        {
          sub_label: 'Deliverable',
          sources: [],
          name: 'address',
          label: 'Office Address',
          category: 'address',
          message: 'The USPS is able to deliver mail to the submitted Office Address',
          key: 'address_deliverability',
          status: 'success',
        },
        {
          sub_label: 'Commercial',
          sources: [],
          name: 'address',
          label: 'Office Address',
          category: 'address',
          message: 'Submitted Office Address is a Commercial property',
          key: 'address_property_type',
          status: 'success',
        },
        {
          sub_label: 'Low',
          sources: [],
          name: 'address',
          label: 'Address Risk',
          category: 'address',
          message: 'Address risk is low',
          key: 'address_risk',
          status: 'success',
        },
        {
          sub_label: 'Low frequency',
          sources: [],
          name: 'address',
          label: 'Office Address',
          category: 'address',
          message: '1 business uses this location',
          key: 'location_frequency',
          status: 'success',
        },
        {
          sub_label: 'No Hits',
          sources: [],
          name: 'watchlist',
          label: 'Watchlist',
          category: 'watchlist',
          message: 'No Watchlist hits were identified',
          key: 'watchlist',
          status: 'success',
        },
        {
          sub_label: 'None Found',
          sources: [],
          name: 'bankruptcies',
          label: 'Bankruptcies',
          category: 'bankruptcies',
          message: 'The business has no bankruptcy filings',
          key: 'bankruptcies',
          status: 'success',
        },
      ],
      object: 'review',
    },
    tin: {
      verified_by: 'business',
      updated_at: '2026-02-20T17:07:33.834Z',
      mismatch: true,
      name: 'MATCHING INC',
      verified: false,
      tin: '11-0000099',
      error: null,
      issued: true,
      business_id: '5f9d0d33-88bf-405b-a3f6-ec4b52f4230e',
      unknown: false,
    },
    id: '5f9d0d33-88bf-405b-a3f6-ec4b52f4230e',
    signal: null,
    supported_document_types: [],
    business_batch_id: null,
    assignee_id: '43b518e0-8921-49c9-b94a-40dcd649020b',
    requester: {
      name: 'Dill',
      id: 'f2b57db4-d781-471b-9b73-e878eb420f67',
      type: 'account',
      requested_at: '2026-02-20T17:07:33.488Z',
    },
    website: null,
    registrations: [],
    litigations: [],
    profiles: [],
    monitor: null,
    certifications: [],
    people: [],
    liens: [],
    tags: [],
    phone_numbers: [],
    names: [
      {
        submitted: true,
        sources: [],
        name: 'Unregistered Business',
        id: '1c43b91e-9932-4366-b2b7-a0d9291ea127',
        type: 'legal',
        business_id: '5f9d0d33-88bf-405b-a3f6-ec4b52f4230e',
        object: 'name',
      },
    ],
    submitted: {
      email_addresses: null,
      addresses: [
        {
          city: 'New York',
          address_line1: '123 Grand St.',
          state: 'NY',
          postal_code: '10013',
        },
      ],
      website: {},
      profiles: [],
      external_id: null,
      formation: null,
      people: [],
      tags: null,
      phone_numbers: [],
      entity_type: null,
      names: null,
      name: 'Unregistered Business',
      tin: {
        tin: '110000099',
      },
      unique_external_id: null,
      orders: null,
      object: 'submitted_attributes',
      assignee_id: null,
    },
    politically_exposed_person_screening: null,
    policy_results: [],
    name: 'Unregistered Business',
    unique_external_id: null,
    orders: [
      {
        requester: {
          name: 'Dill',
          type: 'account',
        },
        completed_at: '2026-02-20T17:07:34.170Z',
        product: 'business_verification_verify',
        package: 'business_verification_verify',
        updated_at: '2026-02-20T17:07:34.473Z',
        created_at: '2026-02-20T17:07:33.488Z',
        id: '6942b2e5-a1f9-4740-ba8e-b708cb87a4f3',
        monitoring: false,
        business_id: '5f9d0d33-88bf-405b-a3f6-ec4b52f4230e',
        subproducts: [],
        object: 'order',
        status: 'completed',
      },
      {
        requester: {
          name: 'Dill',
          type: 'account',
        },
        completed_at: '2026-02-20T17:07:34.394Z',
        product: 'bankruptcies',
        package: 'bankruptcies',
        updated_at: '2026-02-20T17:07:34.605Z',
        created_at: '2026-02-20T17:07:33.492Z',
        id: 'd956698d-94c7-4aea-a034-c32dcbb618c1',
        monitoring: false,
        business_id: '5f9d0d33-88bf-405b-a3f6-ec4b52f4230e',
        subproducts: [],
        object: 'order',
        status: 'completed',
      },
    ],
    tax_exempt_organization: null,
    watchlist: {
      lists: [
        {
          agency: 'Office of Foreign Assets Control',
          organization: 'U.S. Department of Treasury',
          agency_abbr: 'OFAC',
          title: 'Capta List',
          abbr: 'CAP',
          results: [],
          object: 'watchlist_source',
        },
        {
          agency: 'Bureau of Industry and Security',
          organization: 'U.S. Department of Commerce',
          agency_abbr: 'BIS',
          title: 'Denied Persons List',
          abbr: 'DPL',
          results: [],
          object: 'watchlist_source',
        },
        {
          agency: 'Directorate of Defense Trade Controls',
          organization: 'U.S. Department of State',
          agency_abbr: 'DDTC',
          title: 'AECA/ITAR Debarred',
          abbr: 'DTC',
          results: [],
          object: 'watchlist_source',
        },
        {
          agency: 'Bureau of Industry and Security',
          organization: 'U.S. Department of Commerce',
          agency_abbr: 'BIS',
          title: 'Entity List',
          abbr: 'EL',
          results: [],
          object: 'watchlist_source',
        },
        {
          agency: 'Office of Foreign Assets Control',
          organization: 'U.S. Department of Treasury',
          agency_abbr: 'OFAC',
          title: 'Foreign Sanctions Evaders',
          abbr: 'FSE',
          results: [],
          object: 'watchlist_source',
        },
        {
          agency: 'Bureau of International Security and Non-Proliferation',
          organization: 'U.S. Department of State',
          agency_abbr: 'ISN',
          title: 'Nonproliferation Sanctions',
          abbr: 'ISN',
          results: [],
          object: 'watchlist_source',
        },
        {
          agency: 'Bureau of Industry and Security',
          organization: 'U.S. Department of Commerce',
          agency_abbr: 'BIS',
          title: 'Military End User',
          abbr: 'MEU',
          results: [],
          object: 'watchlist_source',
        },
        {
          agency: 'Office of Foreign Assets Control',
          organization: 'U.S. Department of Treasury',
          agency_abbr: 'OFAC',
          title: 'Non-SDN Chinese Military-Industrial Complex Companies List',
          abbr: 'NS-CMIC',
          results: [],
          object: 'watchlist_source',
        },
        {
          agency: 'Office of Foreign Assets Control',
          organization: 'U.S. Department of Treasury',
          agency_abbr: 'OFAC',
          title: 'Non-SDN Iranian Sanctions',
          abbr: 'NS-ISA',
          results: [],
          object: 'watchlist_source',
        },
        {
          agency: 'Office of Foreign Assets Control',
          organization: 'U.S. Department of Treasury',
          agency_abbr: 'OFAC',
          title: 'Non-SDN Menu-Based Sanctions',
          abbr: 'NS-MBS',
          results: [],
          object: 'watchlist_source',
        },
        {
          agency: 'Office of Foreign Assets Control',
          organization: 'U.S. Department of Treasury',
          agency_abbr: 'OFAC',
          title: 'Palestinian Legislative Council',
          abbr: 'PLC',
          results: [],
          object: 'watchlist_source',
        },
        {
          agency: 'Office of Foreign Assets Control',
          organization: 'U.S. Department of Treasury',
          agency_abbr: 'OFAC',
          title: 'Specially Designated Nationals',
          abbr: 'SDN',
          results: [],
          object: 'watchlist_source',
        },
        {
          agency: 'Office of Foreign Assets Control',
          organization: 'U.S. Department of Treasury',
          agency_abbr: 'OFAC',
          title: 'Sectoral Sanctions Identifications',
          abbr: 'SSI',
          results: [],
          object: 'watchlist_source',
        },
        {
          agency: 'Bureau of Industry and Security',
          organization: 'U.S. Department of Commerce',
          agency_abbr: 'BIS',
          title: 'Unverified List',
          abbr: 'UVL',
          results: [],
          object: 'watchlist_source',
        },
      ],
      agencies: [
        {
          org: 'U.S. Department of Treasury',
          name: 'Office of Foreign Assets Control',
          abbr: 'OFAC',
        },
        {
          org: 'U.S. Department of Commerce',
          name: 'Bureau of Industry and Security',
          abbr: 'BIS',
        },
        {
          org: 'U.S. Department of State',
          name: 'Directorate of Defense Trade Controls',
          abbr: 'DDTC',
        },
        {
          org: 'U.S. Department of State',
          name: 'Bureau of International Security and Non-Proliferation',
          abbr: 'ISN',
        },
      ],
      id: 'f5535569-2d5f-4b36-8ce0-c5ef2ad24b4f',
      hit_count: 0,
      people: [],
      object: 'watchlist',
    },
    object: 'business',
    status: 'in_review',
  },
  {
    addresses: [
      {
        is_registered_agent: false,
        sources: [
          {
            metadata: {
              file_number: 'FN-XXXXXXX',
              jurisdiction: 'DOMESTIC',
              state: 'NY',
              labels: [],
              status: 'active',
            },
            id: 'd5d45f5a-fb26-4dc4-900f-1c1e722c99cc',
            type: 'registration',
          },
        ],
        city: 'New York',
        latitude: 40.52,
        street_view_available: false,
        rating: {
          risk_rating: 'high',
          indicators: [
            {
              name: 'Valid US address',
              rating: 'positive',
              description: 'Valid',
              type: 'valid_us_address',
              value: 'valid',
            },
            {
              name: 'Deliverability',
              rating: 'negative',
              description: 'Undeliverable',
              type: 'deliverability',
              value: 'undeliverable',
            },
            {
              name: 'Geographical location',
              rating: 'positive',
              description: 'US',
              type: 'geographical_location',
              value: 'us',
            },
            {
              name: 'Commercial registered agent',
              rating: 'positive',
              description: 'Not a commercial registered agent',
              type: 'registered_agent',
              value: 'not_registered_agent',
            },
            {
              name: 'Private mailbox',
              rating: 'positive',
              description: 'Not a private mailbox',
              type: 'private_mailbox',
              value: 'not_private_mailbox',
            },
            {
              name: 'Location frequency',
              rating: 'positive',
              description: '1 business',
              type: 'location_frequency',
              value: '1_business',
            },
            {
              name: 'Virtual address',
              rating: 'positive',
              description: 'Not a virtual address',
              type: 'virtual_address',
              value: 'not_virtual_address',
            },
          ],
        },
        deliverable: false,
        created_at: '2026-02-20T17:54:05.266Z',
        full_address: '991 st. undeliverable, New York, NY 10013',
        address_line2: null,
        updated_at: '2026-02-20T17:54:05.501Z',
        address_line1: '991 St. Undeliverable',
        property_type: null,
        state: 'NY',
        id: 'a36e2b15-9d1d-4b36-818e-ec3a3d48fc58',
        longitude: 30.4,
        location_count: 1,
        deliverability_analysis: null,
        registered_agent_name: null,
        labels: [],
        submitted: true,
        cmra: false,
        postal_code: '10013',
        business_id: '335be639-72a3-4b30-bf8a-fcc2f921e102',
        object: 'address',
      },
      {
        is_registered_agent: false,
        sources: [
          {
            metadata: {
              file_number: 'FN-XXXXXXX',
              jurisdiction: 'DOMESTIC',
              state: 'NY',
              labels: [],
              status: 'active',
            },
            id: 'd5d45f5a-fb26-4dc4-900f-1c1e722c99cc',
            type: 'registration',
          },
        ],
        city: 'Bronx',
        latitude: null,
        street_view_available: null,
        rating: {
          risk_rating: 'high',
          indicators: [
            {
              name: 'Valid US address',
              rating: 'negative',
              description: 'Invalid',
              type: 'valid_us_address',
              value: 'invalid',
            },
            {
              name: 'Deliverability',
              rating: 'positive',
              description: 'Deliverable',
              type: 'deliverability',
              value: 'deliverable',
            },
            {
              name: 'Geographical location',
              rating: 'negative',
              description: 'Unknown',
              type: 'geographical_location',
              value: 'unknown',
            },
            {
              name: 'Commercial registered agent',
              rating: 'neutral',
              description: 'Unknown',
              type: 'registered_agent',
              value: 'unknown',
            },
            {
              name: 'Private mailbox',
              rating: 'neutral',
              description: 'Unknown',
              type: 'private_mailbox',
              value: 'unknown',
            },
            {
              name: 'Location frequency',
              rating: 'positive',
              description: '1 business',
              type: 'location_frequency',
              value: '1_business',
            },
            {
              name: 'Property type',
              rating: 'neutral',
              description: 'Unknown',
              type: 'property_type',
              value: 'unknown',
            },
          ],
        },
        deliverable: true,
        created_at: '2026-02-20T17:54:05.521Z',
        full_address: '354 Circle Court,Bronx, NY 10468',
        address_line2: null,
        updated_at: '2026-02-20T17:54:05.521Z',
        address_line1: '354 Circle Ct',
        property_type: null,
        state: 'NY',
        id: '88bd2376-362d-4c91-91f2-2d5545be0343',
        longitude: null,
        location_count: 1,
        deliverability_analysis: null,
        registered_agent_name: null,
        labels: [],
        submitted: false,
        cmra: false,
        postal_code: '10468',
        business_id: '335be639-72a3-4b30-bf8a-fcc2f921e102',
        object: 'address',
      },
    ],
    documents: [],
    fmcsa_registrations: [],
    adverse_media_screening: null,
    created_at: '2026-02-20T17:54:05.254Z',
    external_id: null,
    formation: {
      formation_date: '2020-02-24',
      entity_type: 'CORPORATION',
      updated_at: '2026-02-20T17:54:05.731Z',
      sources: [
        {
          metadata: {
            file_number: 'FN-XXXXXXX',
            jurisdiction: 'DOMESTIC',
            state: 'NY',
            status: 'active',
          },
          id: 'd5d45f5a-fb26-4dc4-900f-1c1e722c99cc',
          type: 'registration',
        },
      ],
      formation_state: 'NY',
      created_at: '2026-02-20T17:54:05.731Z',
    },
    subscription: null,
    industry_classification: null,
    updated_at: '2026-02-20T17:54:06.547Z',
    bankruptcies: [],
    review: {
      completed_at: null,
      updated_at: '2026-02-20T17:54:05.418Z',
      created_at: '2026-02-20T17:54:05.418Z',
      id: 'b514d373-ecb6-4b88-ba39-0d6b4ededa9d',
      assignee: {
        settings: {
          receives_agent_emails: false,
        },
        last_login_at: null,
        directory_managed: false,
        image_url:
          'https://www.gravatar.com/avatar/bd43e7168c81bb7fe5b439c8582d59e0?s=64&d=https%3A%2F%2Fapp-sandbox.middesk.com%2Fimages%2Fdefault-avatar.png',
        roles: ['admin', 'member'],
        name: 'Catherine Jiang',
        created_at: '2026-02-17T21:26:07.880Z',
        id: '43b518e0-8921-49c9-b94a-40dcd649020b',
        email: 'catherine@usedill.com',
        object: 'user',
      },
      tasks: [
        {
          sub_label: 'Undeliverable',
          sources: [],
          name: 'address',
          label: 'Office Address',
          category: 'address',
          message: 'The USPS is unable to deliver mail to the submitted Office Address',
          key: 'address_deliverability',
          status: 'failure',
        },
        {
          sub_label: 'High',
          sources: [],
          name: 'address',
          label: 'Address Risk',
          category: 'address',
          message: 'Address risk is high',
          key: 'address_risk',
          status: 'failure',
        },
        {
          sub_label: 'Error',
          sources: [],
          name: 'tin',
          label: 'TIN Match',
          category: 'tin',
          message: 'IRS unavailable',
          key: 'tin',
          status: 'failure',
        },
        {
          sub_label: 'IRS unavailable',
          sources: [],
          name: 'tin',
          label: 'TIN Error',
          category: 'tin',
          message: 'IRS unavailable',
          key: 'tin_error',
          status: 'failure',
        },
        {
          sub_label: 'Similar Match',
          sources: [
            {
              metadata: {
                submitted: true,
                name: 'similar name business',
              },
              id: '1cfada1d-1eba-43a0-bb09-85e7dbc6282a',
              type: 'name',
            },
            {
              metadata: {
                submitted: false,
                name: 'Similar Name Buziness',
              },
              id: '967e0874-5237-4992-99a9-7126188b842a',
              type: 'name',
            },
          ],
          name: 'name',
          label: 'Business Name',
          category: 'name',
          message: 'Similar match identified to the submitted Business Name',
          key: 'name',
          status: 'warning',
        },
        {
          sub_label: 'Verified',
          sources: [
            {
              metadata: {
                submitted: true,
                address_line2: null,
                city: 'New York',
                address_line1: '991 St. Undeliverable',
                state: 'NY',
                full_address: '991 st. undeliverable, New York, NY 10013',
                postal_code: '10013',
              },
              id: 'a36e2b15-9d1d-4b36-818e-ec3a3d48fc58',
              type: 'address',
            },
          ],
          name: 'address',
          label: 'Office Address',
          category: 'address',
          message: 'Match identified to the submitted Office Address',
          key: 'address_verification',
          status: 'success',
        },
        {
          sub_label: 'Commercial',
          sources: [],
          name: 'address',
          label: 'Office Address',
          category: 'address',
          message: 'Submitted Office Address is a Commercial property',
          key: 'address_property_type',
          status: 'success',
        },
        {
          sub_label: 'Low frequency',
          sources: [],
          name: 'address',
          label: 'Office Address',
          category: 'address',
          message: '1 business uses this location',
          key: 'location_frequency',
          status: 'success',
        },
        {
          sub_label: 'Submitted Active',
          sources: [],
          name: 'sos',
          label: 'SOS Filings',
          category: 'sos',
          message: 'The business is Active in the state of the submitted Office Address',
          key: 'sos_match',
          status: 'success',
        },
        {
          sub_label: 'Active',
          sources: [],
          name: 'sos',
          label: 'SOS Filings',
          category: 'sos',
          message: '2 of 2 filings are Active',
          key: 'sos_active',
          status: 'success',
        },
        {
          sub_label: 'Good Standing',
          sources: [],
          name: 'sos',
          label: 'SOS Domestic Sub‑status',
          category: 'sos',
          message: 'The domestic registration is in Good Standing.',
          key: 'sos_domestic_sub_status',
          status: 'success',
        },
        {
          sub_label: 'Domestic Active',
          sources: [],
          name: 'sos',
          label: 'SOS Filings',
          category: 'sos',
          message: 'Active domestic filing found',
          key: 'sos_domestic',
          status: 'success',
        },
        {
          sub_label: 'No Hits',
          sources: [],
          name: 'watchlist',
          label: 'Watchlist',
          category: 'watchlist',
          message: 'No Watchlist hits were identified',
          key: 'watchlist',
          status: 'success',
        },
        {
          sub_label: 'None Found',
          sources: [],
          name: 'bankruptcies',
          label: 'Bankruptcies',
          category: 'bankruptcies',
          message: 'The business has no bankruptcy filings',
          key: 'bankruptcies',
          status: 'success',
        },
      ],
      object: 'review',
    },
    tin: {
      verified_by: null,
      updated_at: '2026-02-20T17:54:05.593Z',
      mismatch: false,
      name: 'similar name business',
      verified: false,
      tin: '33-3444555',
      error: 'irs_unavailable',
      issued: true,
      business_id: '335be639-72a3-4b30-bf8a-fcc2f921e102',
      unknown: true,
    },
    id: '335be639-72a3-4b30-bf8a-fcc2f921e102',
    signal: null,
    supported_document_types: ['Articles of Incorporation', 'Certificate of Good Standing'],
    business_batch_id: null,
    assignee_id: '43b518e0-8921-49c9-b94a-40dcd649020b',
    requester: {
      name: 'Dill',
      id: 'f2b57db4-d781-471b-9b73-e878eb420f67',
      type: 'account',
      requested_at: '2026-02-20T17:54:05.273Z',
    },
    website: null,
    registrations: [
      {
        addresses: [
          '991 ST. UNDELIVERABLE, NEW YORK, NY 10013',
          '354 CIRCLE COURT,BRONX, NY 10468',
        ],
        registered_agent: {},
        sub_status: 'GOOD_STANDING',
        jurisdiction: 'DOMESTIC',
        source: 'https://apps.dos.ny.gov/publicInquiry/',
        file_number: 'FN-XXXXXXX',
        entity_type: 'CORPORATION',
        registration_date: '2020-02-24',
        name: 'Similar Name Buziness',
        id: 'd5d45f5a-fb26-4dc4-900f-1c1e722c99cc',
        state: 'NY',
        business_id: '335be639-72a3-4b30-bf8a-fcc2f921e102',
        status_details: 'Active-Good Standing',
        officers: [],
        object: 'registration',
        status: 'active',
      },
      {
        addresses: [
          '991 ST. UNDELIVERABLE, NEW YORK, NY 10013',
          '354 CIRCLE COURT,BRONX, NY 10468',
        ],
        registered_agent: {},
        sub_status: null,
        jurisdiction: 'FOREIGN',
        source: 'https://www.sos.state.co.us/biz/BusinessEntityCriteriaExt.do',
        file_number: '12345135135',
        entity_type: 'CORPORATION',
        registration_date: '2020-02-24',
        name: 'Similar Name Buziness',
        id: 'c18ac4f5-c810-4dec-b0b6-2c082e5f38dd',
        state: 'CO',
        business_id: '335be639-72a3-4b30-bf8a-fcc2f921e102',
        status_details: null,
        officers: [],
        object: 'registration',
        status: 'active',
      },
    ],
    litigations: [],
    profiles: [],
    monitor: null,
    certifications: [],
    people: [],
    liens: [],
    tags: [],
    phone_numbers: [],
    names: [
      {
        submitted: true,
        sources: [],
        name: 'similar name business',
        id: '1cfada1d-1eba-43a0-bb09-85e7dbc6282a',
        type: 'legal',
        business_id: '335be639-72a3-4b30-bf8a-fcc2f921e102',
        object: 'name',
      },
      {
        submitted: false,
        sources: [
          {
            metadata: {
              file_number: 'FN-XXXXXXX',
              jurisdiction: 'DOMESTIC',
              state: 'NY',
              status: 'active',
            },
            id: 'd5d45f5a-fb26-4dc4-900f-1c1e722c99cc',
            type: 'registration',
          },
        ],
        name: 'Similar Name Buziness',
        id: '967e0874-5237-4992-99a9-7126188b842a',
        type: null,
        business_id: '335be639-72a3-4b30-bf8a-fcc2f921e102',
        object: 'name',
      },
    ],
    submitted: {
      email_addresses: null,
      addresses: [
        {
          city: 'New York',
          address_line1: '991 st. undeliverable',
          state: 'NY',
          postal_code: '10013',
        },
      ],
      website: {},
      profiles: [],
      external_id: null,
      formation: null,
      people: [],
      tags: null,
      phone_numbers: [],
      entity_type: null,
      names: null,
      name: 'similar name business',
      tin: {
        tin: '333444555',
      },
      unique_external_id: null,
      orders: null,
      object: 'submitted_attributes',
      assignee_id: null,
    },
    politically_exposed_person_screening: null,
    policy_results: [],
    name: 'similar name business',
    unique_external_id: null,
    orders: [
      {
        requester: {
          name: 'Dill',
          type: 'account',
        },
        completed_at: '2026-02-20T17:54:06.003Z',
        product: 'business_verification_verify',
        package: 'business_verification_verify',
        updated_at: '2026-02-20T17:54:06.328Z',
        created_at: '2026-02-20T17:54:05.273Z',
        id: 'ccb7f6fa-7ed9-4492-b118-e7010592f3b7',
        monitoring: false,
        business_id: '335be639-72a3-4b30-bf8a-fcc2f921e102',
        subproducts: [],
        object: 'order',
        status: 'completed',
      },
      {
        requester: {
          name: 'Dill',
          type: 'account',
        },
        completed_at: '2026-02-20T17:54:06.312Z',
        product: 'bankruptcies',
        package: 'bankruptcies',
        updated_at: '2026-02-20T17:54:06.599Z',
        created_at: '2026-02-20T17:54:05.277Z',
        id: 'c43e74f9-e34b-4a9c-8fd3-696340f17763',
        monitoring: false,
        business_id: '335be639-72a3-4b30-bf8a-fcc2f921e102',
        subproducts: [],
        object: 'order',
        status: 'completed',
      },
    ],
    tax_exempt_organization: null,
    watchlist: {
      lists: [
        {
          agency: 'Office of Foreign Assets Control',
          organization: 'U.S. Department of Treasury',
          agency_abbr: 'OFAC',
          title: 'Capta List',
          abbr: 'CAP',
          results: [],
          object: 'watchlist_source',
        },
        {
          agency: 'Bureau of Industry and Security',
          organization: 'U.S. Department of Commerce',
          agency_abbr: 'BIS',
          title: 'Denied Persons List',
          abbr: 'DPL',
          results: [],
          object: 'watchlist_source',
        },
        {
          agency: 'Directorate of Defense Trade Controls',
          organization: 'U.S. Department of State',
          agency_abbr: 'DDTC',
          title: 'AECA/ITAR Debarred',
          abbr: 'DTC',
          results: [],
          object: 'watchlist_source',
        },
        {
          agency: 'Bureau of Industry and Security',
          organization: 'U.S. Department of Commerce',
          agency_abbr: 'BIS',
          title: 'Entity List',
          abbr: 'EL',
          results: [],
          object: 'watchlist_source',
        },
        {
          agency: 'Office of Foreign Assets Control',
          organization: 'U.S. Department of Treasury',
          agency_abbr: 'OFAC',
          title: 'Foreign Sanctions Evaders',
          abbr: 'FSE',
          results: [],
          object: 'watchlist_source',
        },
        {
          agency: 'Bureau of International Security and Non-Proliferation',
          organization: 'U.S. Department of State',
          agency_abbr: 'ISN',
          title: 'Nonproliferation Sanctions',
          abbr: 'ISN',
          results: [],
          object: 'watchlist_source',
        },
        {
          agency: 'Bureau of Industry and Security',
          organization: 'U.S. Department of Commerce',
          agency_abbr: 'BIS',
          title: 'Military End User',
          abbr: 'MEU',
          results: [],
          object: 'watchlist_source',
        },
        {
          agency: 'Office of Foreign Assets Control',
          organization: 'U.S. Department of Treasury',
          agency_abbr: 'OFAC',
          title: 'Non-SDN Chinese Military-Industrial Complex Companies List',
          abbr: 'NS-CMIC',
          results: [],
          object: 'watchlist_source',
        },
        {
          agency: 'Office of Foreign Assets Control',
          organization: 'U.S. Department of Treasury',
          agency_abbr: 'OFAC',
          title: 'Non-SDN Iranian Sanctions',
          abbr: 'NS-ISA',
          results: [],
          object: 'watchlist_source',
        },
        {
          agency: 'Office of Foreign Assets Control',
          organization: 'U.S. Department of Treasury',
          agency_abbr: 'OFAC',
          title: 'Non-SDN Menu-Based Sanctions',
          abbr: 'NS-MBS',
          results: [],
          object: 'watchlist_source',
        },
        {
          agency: 'Office of Foreign Assets Control',
          organization: 'U.S. Department of Treasury',
          agency_abbr: 'OFAC',
          title: 'Palestinian Legislative Council',
          abbr: 'PLC',
          results: [],
          object: 'watchlist_source',
        },
        {
          agency: 'Office of Foreign Assets Control',
          organization: 'U.S. Department of Treasury',
          agency_abbr: 'OFAC',
          title: 'Specially Designated Nationals',
          abbr: 'SDN',
          results: [],
          object: 'watchlist_source',
        },
        {
          agency: 'Office of Foreign Assets Control',
          organization: 'U.S. Department of Treasury',
          agency_abbr: 'OFAC',
          title: 'Sectoral Sanctions Identifications',
          abbr: 'SSI',
          results: [],
          object: 'watchlist_source',
        },
        {
          agency: 'Bureau of Industry and Security',
          organization: 'U.S. Department of Commerce',
          agency_abbr: 'BIS',
          title: 'Unverified List',
          abbr: 'UVL',
          results: [],
          object: 'watchlist_source',
        },
      ],
      agencies: [
        {
          org: 'U.S. Department of Treasury',
          name: 'Office of Foreign Assets Control',
          abbr: 'OFAC',
        },
        {
          org: 'U.S. Department of Commerce',
          name: 'Bureau of Industry and Security',
          abbr: 'BIS',
        },
        {
          org: 'U.S. Department of State',
          name: 'Directorate of Defense Trade Controls',
          abbr: 'DDTC',
        },
        {
          org: 'U.S. Department of State',
          name: 'Bureau of International Security and Non-Proliferation',
          abbr: 'ISN',
        },
      ],
      id: 'c4f34d54-30b8-4bf7-82d2-92a9c4e7cf2b',
      hit_count: 0,
      people: [],
      object: 'watchlist',
    },
    object: 'business',
    status: 'in_review',
  },
  {
    addresses: [
      {
        is_registered_agent: false,
        sources: [
          {
            metadata: {
              file_number: 'FN-XXXXXXX',
              jurisdiction: 'DOMESTIC',
              state: 'CA',
              labels: [],
              status: 'inactive',
            },
            id: '9110e32d-aa3f-46a7-ab3f-8b2f60fc3e13',
            type: 'registration',
          },
        ],
        city: 'Newport Beach',
        latitude: 40.52,
        street_view_available: false,
        rating: {
          risk_rating: 'low',
          indicators: [
            {
              name: 'Valid US address',
              rating: 'positive',
              description: 'Valid',
              type: 'valid_us_address',
              value: 'valid',
            },
            {
              name: 'Deliverability',
              rating: 'positive',
              description: 'Deliverable',
              type: 'deliverability',
              value: 'deliverable',
            },
            {
              name: 'Geographical location',
              rating: 'positive',
              description: 'US',
              type: 'geographical_location',
              value: 'us',
            },
            {
              name: 'Commercial registered agent',
              rating: 'positive',
              description: 'Not a commercial registered agent',
              type: 'registered_agent',
              value: 'not_registered_agent',
            },
            {
              name: 'Private mailbox',
              rating: 'positive',
              description: 'Not a private mailbox',
              type: 'private_mailbox',
              value: 'not_private_mailbox',
            },
            {
              name: 'Location frequency',
              rating: 'positive',
              description: '1 business',
              type: 'location_frequency',
              value: '1_business',
            },
            {
              name: 'Virtual address',
              rating: 'positive',
              description: 'Not a virtual address',
              type: 'virtual_address',
              value: 'not_virtual_address',
            },
          ],
        },
        deliverable: true,
        created_at: '2026-02-20T18:00:21.452Z',
        full_address: '3300 Newport Blvd, Newport Beach, CA 92663-3816',
        address_line2: null,
        updated_at: '2026-02-20T18:00:21.749Z',
        address_line1: '3300 Newport Blvd',
        property_type: null,
        state: 'CA',
        id: '645699bb-515a-4a16-98b9-3f81ea1c3fc1',
        longitude: 30.4,
        location_count: 1,
        deliverability_analysis: null,
        registered_agent_name: null,
        labels: [],
        submitted: true,
        cmra: false,
        postal_code: '92663',
        business_id: 'af4838db-b150-421b-a60b-bed81580b0b3',
        object: 'address',
      },
      {
        is_registered_agent: false,
        sources: [
          {
            metadata: {
              file_number: 'FN-XXXXXXX',
              jurisdiction: 'DOMESTIC',
              state: 'CA',
              labels: [],
              status: 'inactive',
            },
            id: '9110e32d-aa3f-46a7-ab3f-8b2f60fc3e13',
            type: 'registration',
          },
        ],
        city: 'Bronx',
        latitude: null,
        street_view_available: null,
        rating: {
          risk_rating: 'high',
          indicators: [
            {
              name: 'Valid US address',
              rating: 'negative',
              description: 'Invalid',
              type: 'valid_us_address',
              value: 'invalid',
            },
            {
              name: 'Deliverability',
              rating: 'positive',
              description: 'Deliverable',
              type: 'deliverability',
              value: 'deliverable',
            },
            {
              name: 'Geographical location',
              rating: 'negative',
              description: 'Unknown',
              type: 'geographical_location',
              value: 'unknown',
            },
            {
              name: 'Commercial registered agent',
              rating: 'neutral',
              description: 'Unknown',
              type: 'registered_agent',
              value: 'unknown',
            },
            {
              name: 'Private mailbox',
              rating: 'neutral',
              description: 'Unknown',
              type: 'private_mailbox',
              value: 'unknown',
            },
            {
              name: 'Location frequency',
              rating: 'positive',
              description: '1 business',
              type: 'location_frequency',
              value: '1_business',
            },
            {
              name: 'Property type',
              rating: 'neutral',
              description: 'Unknown',
              type: 'property_type',
              value: 'unknown',
            },
          ],
        },
        deliverable: true,
        created_at: '2026-02-20T18:00:21.769Z',
        full_address: '354 Circle Court,Bronx, NY 10468',
        address_line2: null,
        updated_at: '2026-02-20T18:00:21.769Z',
        address_line1: '354 Circle Ct',
        property_type: null,
        state: 'NY',
        id: '3a42b980-bdf0-4ba6-b99d-e802ee52f839',
        longitude: null,
        location_count: 1,
        deliverability_analysis: null,
        registered_agent_name: null,
        labels: [],
        submitted: false,
        cmra: false,
        postal_code: '10468',
        business_id: 'af4838db-b150-421b-a60b-bed81580b0b3',
        object: 'address',
      },
    ],
    documents: [],
    fmcsa_registrations: [],
    adverse_media_screening: null,
    created_at: '2026-02-20T18:00:21.439Z',
    external_id: null,
    formation: {
      formation_date: '2020-02-24',
      entity_type: 'UNKNOWN',
      updated_at: '2026-02-20T18:00:22.021Z',
      sources: [
        {
          metadata: {
            file_number: 'FN-XXXXXXX',
            jurisdiction: 'DOMESTIC',
            state: 'CA',
            status: 'inactive',
          },
          id: '9110e32d-aa3f-46a7-ab3f-8b2f60fc3e13',
          type: 'registration',
        },
      ],
      formation_state: 'CA',
      created_at: '2026-02-20T18:00:22.021Z',
    },
    subscription: null,
    industry_classification: null,
    updated_at: '2026-02-20T18:00:22.893Z',
    bankruptcies: [],
    review: {
      completed_at: null,
      updated_at: '2026-02-20T18:00:21.651Z',
      created_at: '2026-02-20T18:00:21.651Z',
      id: 'd4998d43-1c4f-47a8-a28b-a9a4fdaa8121',
      assignee: {
        settings: {
          receives_agent_emails: false,
        },
        last_login_at: null,
        directory_managed: false,
        image_url:
          'https://www.gravatar.com/avatar/bd43e7168c81bb7fe5b439c8582d59e0?s=64&d=https%3A%2F%2Fapp-sandbox.middesk.com%2Fimages%2Fdefault-avatar.png',
        roles: ['admin', 'member'],
        name: 'Catherine Jiang',
        created_at: '2026-02-17T21:26:07.880Z',
        id: '43b518e0-8921-49c9-b94a-40dcd649020b',
        email: 'catherine@usedill.com',
        object: 'user',
      },
      tasks: [
        {
          sub_label: 'Submitted Inactive',
          sources: [],
          name: 'sos',
          label: 'SOS Filings',
          category: 'sos',
          message: 'The business is Inactive in the state of the submitted Office Address',
          key: 'sos_match',
          status: 'failure',
        },
        {
          sub_label: 'Inactive',
          sources: [],
          name: 'sos',
          label: 'SOS Filings',
          category: 'sos',
          message: 'The business has no Active Secretary of State filings',
          key: 'sos_inactive',
          status: 'failure',
        },
        {
          sub_label: 'Dissolved',
          sources: [],
          name: 'sos',
          label: 'SOS Domestic Sub‑status',
          category: 'sos',
          message: 'The domestic registration is Dissolved.',
          key: 'sos_domestic_sub_status',
          status: 'failure',
        },
        {
          sub_label: 'Absolute Comfort',
          sources: [],
          name: 'sos',
          label: 'SOS Filings',
          category: 'sos',
          message: 'Inactive domestic filing found',
          key: 'sos_domestic',
          status: 'failure',
        },
        {
          sub_label: 'Error',
          sources: [],
          name: 'tin',
          label: 'TIN Match',
          category: 'tin',
          message: 'Invalid TIN',
          key: 'tin',
          status: 'failure',
        },
        {
          sub_label: 'Not Issued',
          sources: [],
          name: 'tin',
          label: 'TIN Match',
          category: 'tin',
          message:
            'TIN has not been issued by the IRS. There is often a delay after formation for the IRS database to process TINs for new businesses.',
          key: 'tin_issued',
          status: 'failure',
        },
        {
          sub_label: 'Invalid TIN',
          sources: [],
          name: 'tin',
          label: 'TIN Error',
          category: 'tin',
          message: 'Invalid TIN',
          key: 'tin_error',
          status: 'failure',
        },
        {
          sub_label: 'Verified',
          sources: [
            {
              metadata: {
                submitted: true,
                name: 'Absolute Comfort',
              },
              id: '7feb9a8a-547f-4881-bdb7-2499bc89a148',
              type: 'name',
            },
          ],
          name: 'name',
          label: 'Business Name',
          category: 'name',
          message: 'Match identified to the submitted Business Name',
          key: 'name',
          status: 'success',
        },
        {
          sub_label: 'Verified',
          sources: [
            {
              metadata: {
                submitted: true,
                address_line2: null,
                city: 'Newport Beach',
                address_line1: '3300 Newport Blvd',
                state: 'CA',
                full_address: '3300 Newport Blvd, Newport Beach, CA 92663-3816',
                postal_code: '92663',
              },
              id: '645699bb-515a-4a16-98b9-3f81ea1c3fc1',
              type: 'address',
            },
          ],
          name: 'address',
          label: 'Office Address',
          category: 'address',
          message: 'Match identified to the submitted Office Address',
          key: 'address_verification',
          status: 'success',
        },
        {
          sub_label: 'Deliverable',
          sources: [],
          name: 'address',
          label: 'Office Address',
          category: 'address',
          message: 'The USPS is able to deliver mail to the submitted Office Address',
          key: 'address_deliverability',
          status: 'success',
        },
        {
          sub_label: 'Commercial',
          sources: [],
          name: 'address',
          label: 'Office Address',
          category: 'address',
          message: 'Submitted Office Address is a Commercial property',
          key: 'address_property_type',
          status: 'success',
        },
        {
          sub_label: 'Low',
          sources: [],
          name: 'address',
          label: 'Address Risk',
          category: 'address',
          message: 'Address risk is low',
          key: 'address_risk',
          status: 'success',
        },
        {
          sub_label: 'Low frequency',
          sources: [],
          name: 'address',
          label: 'Office Address',
          category: 'address',
          message: '1 business uses this location',
          key: 'location_frequency',
          status: 'success',
        },
        {
          sub_label: 'No Hits',
          sources: [],
          name: 'watchlist',
          label: 'Watchlist',
          category: 'watchlist',
          message: 'No Watchlist hits were identified',
          key: 'watchlist',
          status: 'success',
        },
        {
          sub_label: 'None Found',
          sources: [],
          name: 'bankruptcies',
          label: 'Bankruptcies',
          category: 'bankruptcies',
          message: 'The business has no bankruptcy filings',
          key: 'bankruptcies',
          status: 'success',
        },
      ],
      object: 'review',
    },
    tin: {
      verified_by: null,
      updated_at: '2026-02-20T18:00:21.823Z',
      mismatch: false,
      name: 'Absolute Comfort',
      verified: false,
      tin: '11-222333',
      error: 'invalid_tin',
      issued: false,
      business_id: 'af4838db-b150-421b-a60b-bed81580b0b3',
      unknown: false,
    },
    id: 'af4838db-b150-421b-a60b-bed81580b0b3',
    signal: null,
    supported_document_types: ['Articles of Incorporation', 'Certificate of Good Standing'],
    business_batch_id: null,
    assignee_id: '43b518e0-8921-49c9-b94a-40dcd649020b',
    requester: {
      name: 'Dill',
      id: 'f2b57db4-d781-471b-9b73-e878eb420f67',
      type: 'account',
      requested_at: '2026-02-20T18:00:21.461Z',
    },
    website: null,
    registrations: [
      {
        addresses: [
          '3300 NEWPORT BLVD, NEWPORT BEACH, CA 92663',
          '354 CIRCLE COURT,BRONX, NY 10468',
        ],
        registered_agent: {},
        sub_status: 'DISSOLVED',
        jurisdiction: 'DOMESTIC',
        source: 'https://bizfileonline.sos.ca.gov/search/business',
        file_number: 'FN-XXXXXXX',
        entity_type: 'UNKNOWN',
        registration_date: '2020-02-24',
        name: 'Absolute Comfort',
        id: '9110e32d-aa3f-46a7-ab3f-8b2f60fc3e13',
        state: 'CA',
        business_id: 'af4838db-b150-421b-a60b-bed81580b0b3',
        status_details: 'Voluntarily Dissolved',
        officers: [],
        object: 'registration',
        status: 'inactive',
      },
      {
        addresses: [
          '3300 NEWPORT BLVD, NEWPORT BEACH, CA 92663',
          '354 CIRCLE COURT,BRONX, NY 10468',
        ],
        registered_agent: {},
        sub_status: null,
        jurisdiction: 'FOREIGN',
        source: 'https://www.sos.state.co.us/biz/BusinessEntityCriteriaExt.do',
        file_number: '12345135135',
        entity_type: 'UNKNOWN',
        registration_date: '2020-02-24',
        name: 'Absolute Comfort',
        id: '38498fb5-ec9d-42ed-9f91-ffc3c08dfa14',
        state: 'CO',
        business_id: 'af4838db-b150-421b-a60b-bed81580b0b3',
        status_details: null,
        officers: [],
        object: 'registration',
        status: 'inactive',
      },
    ],
    litigations: [],
    profiles: [],
    monitor: null,
    certifications: [],
    people: [],
    liens: [],
    tags: [],
    phone_numbers: [],
    names: [
      {
        submitted: true,
        sources: [
          {
            metadata: {
              file_number: 'FN-XXXXXXX',
              jurisdiction: 'DOMESTIC',
              state: 'CA',
              status: 'inactive',
            },
            id: '9110e32d-aa3f-46a7-ab3f-8b2f60fc3e13',
            type: 'registration',
          },
        ],
        name: 'Absolute Comfort',
        id: '7feb9a8a-547f-4881-bdb7-2499bc89a148',
        type: 'legal',
        business_id: 'af4838db-b150-421b-a60b-bed81580b0b3',
        object: 'name',
      },
    ],
    submitted: {
      email_addresses: null,
      addresses: [
        {
          city: 'Newport Beach',
          address_line1: '3300 Newport Blvd',
          state: 'CA',
          postal_code: '92663-3816',
        },
      ],
      website: {},
      profiles: [],
      external_id: null,
      formation: null,
      people: [],
      tags: null,
      phone_numbers: [],
      entity_type: null,
      names: null,
      name: 'Absolute Comfort',
      tin: {
        tin: '11222333',
      },
      unique_external_id: null,
      orders: null,
      object: 'submitted_attributes',
      assignee_id: null,
    },
    politically_exposed_person_screening: null,
    policy_results: [],
    name: 'Absolute Comfort',
    unique_external_id: null,
    orders: [
      {
        requester: {
          name: 'Dill',
          type: 'account',
        },
        completed_at: '2026-02-20T18:00:22.676Z',
        product: 'bankruptcies',
        package: 'bankruptcies',
        updated_at: '2026-02-20T18:00:22.955Z',
        created_at: '2026-02-20T18:00:21.465Z',
        id: '6efd72ee-a2ce-40f1-b35b-3e2df0c848c2',
        monitoring: false,
        business_id: 'af4838db-b150-421b-a60b-bed81580b0b3',
        subproducts: [],
        object: 'order',
        status: 'completed',
      },
      {
        requester: {
          name: 'Dill',
          type: 'account',
        },
        completed_at: '2026-02-20T18:00:22.354Z',
        product: 'business_verification_verify',
        package: 'business_verification_verify',
        updated_at: '2026-02-20T18:00:22.752Z',
        created_at: '2026-02-20T18:00:21.461Z',
        id: 'fcf09b5f-c3ef-4515-bdc2-b40704246bbe',
        monitoring: false,
        business_id: 'af4838db-b150-421b-a60b-bed81580b0b3',
        subproducts: [],
        object: 'order',
        status: 'completed',
      },
    ],
    tax_exempt_organization: null,
    watchlist: {
      lists: [
        {
          agency: 'Office of Foreign Assets Control',
          organization: 'U.S. Department of Treasury',
          agency_abbr: 'OFAC',
          title: 'Capta List',
          abbr: 'CAP',
          results: [],
          object: 'watchlist_source',
        },
        {
          agency: 'Bureau of Industry and Security',
          organization: 'U.S. Department of Commerce',
          agency_abbr: 'BIS',
          title: 'Denied Persons List',
          abbr: 'DPL',
          results: [],
          object: 'watchlist_source',
        },
        {
          agency: 'Directorate of Defense Trade Controls',
          organization: 'U.S. Department of State',
          agency_abbr: 'DDTC',
          title: 'AECA/ITAR Debarred',
          abbr: 'DTC',
          results: [],
          object: 'watchlist_source',
        },
        {
          agency: 'Bureau of Industry and Security',
          organization: 'U.S. Department of Commerce',
          agency_abbr: 'BIS',
          title: 'Entity List',
          abbr: 'EL',
          results: [],
          object: 'watchlist_source',
        },
        {
          agency: 'Office of Foreign Assets Control',
          organization: 'U.S. Department of Treasury',
          agency_abbr: 'OFAC',
          title: 'Foreign Sanctions Evaders',
          abbr: 'FSE',
          results: [],
          object: 'watchlist_source',
        },
        {
          agency: 'Bureau of International Security and Non-Proliferation',
          organization: 'U.S. Department of State',
          agency_abbr: 'ISN',
          title: 'Nonproliferation Sanctions',
          abbr: 'ISN',
          results: [],
          object: 'watchlist_source',
        },
        {
          agency: 'Bureau of Industry and Security',
          organization: 'U.S. Department of Commerce',
          agency_abbr: 'BIS',
          title: 'Military End User',
          abbr: 'MEU',
          results: [],
          object: 'watchlist_source',
        },
        {
          agency: 'Office of Foreign Assets Control',
          organization: 'U.S. Department of Treasury',
          agency_abbr: 'OFAC',
          title: 'Non-SDN Chinese Military-Industrial Complex Companies List',
          abbr: 'NS-CMIC',
          results: [],
          object: 'watchlist_source',
        },
        {
          agency: 'Office of Foreign Assets Control',
          organization: 'U.S. Department of Treasury',
          agency_abbr: 'OFAC',
          title: 'Non-SDN Iranian Sanctions',
          abbr: 'NS-ISA',
          results: [],
          object: 'watchlist_source',
        },
        {
          agency: 'Office of Foreign Assets Control',
          organization: 'U.S. Department of Treasury',
          agency_abbr: 'OFAC',
          title: 'Non-SDN Menu-Based Sanctions',
          abbr: 'NS-MBS',
          results: [],
          object: 'watchlist_source',
        },
        {
          agency: 'Office of Foreign Assets Control',
          organization: 'U.S. Department of Treasury',
          agency_abbr: 'OFAC',
          title: 'Palestinian Legislative Council',
          abbr: 'PLC',
          results: [],
          object: 'watchlist_source',
        },
        {
          agency: 'Office of Foreign Assets Control',
          organization: 'U.S. Department of Treasury',
          agency_abbr: 'OFAC',
          title: 'Specially Designated Nationals',
          abbr: 'SDN',
          results: [],
          object: 'watchlist_source',
        },
        {
          agency: 'Office of Foreign Assets Control',
          organization: 'U.S. Department of Treasury',
          agency_abbr: 'OFAC',
          title: 'Sectoral Sanctions Identifications',
          abbr: 'SSI',
          results: [],
          object: 'watchlist_source',
        },
        {
          agency: 'Bureau of Industry and Security',
          organization: 'U.S. Department of Commerce',
          agency_abbr: 'BIS',
          title: 'Unverified List',
          abbr: 'UVL',
          results: [],
          object: 'watchlist_source',
        },
      ],
      agencies: [
        {
          org: 'U.S. Department of Treasury',
          name: 'Office of Foreign Assets Control',
          abbr: 'OFAC',
        },
        {
          org: 'U.S. Department of Commerce',
          name: 'Bureau of Industry and Security',
          abbr: 'BIS',
        },
        {
          org: 'U.S. Department of State',
          name: 'Directorate of Defense Trade Controls',
          abbr: 'DDTC',
        },
        {
          org: 'U.S. Department of State',
          name: 'Bureau of International Security and Non-Proliferation',
          abbr: 'ISN',
        },
      ],
      id: '13a0a127-1d64-487c-aef2-e6ae77496894',
      hit_count: 0,
      people: [],
      object: 'watchlist',
    },
    object: 'business',
    status: 'in_review',
  },
  {
    addresses: [
      {
        is_registered_agent: true,
        sources: [
          {
            metadata: {
              file_number: 'FN-XXXXXXX',
              jurisdiction: 'DOMESTIC',
              state: 'NY',
              labels: [],
              status: 'active',
            },
            id: 'e6806101-c0c9-4cbe-bfb5-ae6a36bf8d5c',
            type: 'registration',
          },
        ],
        city: 'New York',
        latitude: 40.52,
        street_view_available: false,
        rating: {
          risk_rating: 'high',
          indicators: [
            {
              name: 'Valid US address',
              rating: 'positive',
              description: 'Valid',
              type: 'valid_us_address',
              value: 'valid',
            },
            {
              name: 'Deliverability',
              rating: 'positive',
              description: 'Deliverable',
              type: 'deliverability',
              value: 'deliverable',
            },
            {
              name: 'Geographical location',
              rating: 'positive',
              description: 'US',
              type: 'geographical_location',
              value: 'us',
            },
            {
              name: 'Commercial registered agent',
              rating: 'negative',
              description: 'Registered agent',
              type: 'registered_agent',
              value: 'registered_agent',
            },
            {
              name: 'Private mailbox',
              rating: 'positive',
              description: 'Not a private mailbox',
              type: 'private_mailbox',
              value: 'not_private_mailbox',
            },
            {
              name: 'Location frequency',
              rating: 'positive',
              description: '1 business',
              type: 'location_frequency',
              value: '1_business',
            },
            {
              name: 'Virtual address',
              rating: 'positive',
              description: 'Not a virtual address',
              type: 'virtual_address',
              value: 'not_virtual_address',
            },
          ],
        },
        deliverable: true,
        created_at: '2026-02-20T17:30:04.335Z',
        full_address: '991 registered agent st., New York, NY 10013',
        address_line2: null,
        updated_at: '2026-02-20T17:30:04.565Z',
        address_line1: '991 Registered Agent St',
        property_type: null,
        state: 'NY',
        id: 'e8d80114-95d0-44c3-8261-76c6d2a7519f',
        longitude: 30.4,
        location_count: 1,
        deliverability_analysis: null,
        registered_agent_name: 'CT Corp',
        labels: ['registered_agent'],
        submitted: true,
        cmra: false,
        postal_code: '10013',
        business_id: 'df2690f4-b310-4e4e-b356-e4cde4ed8edb',
        object: 'address',
      },
      {
        is_registered_agent: false,
        sources: [
          {
            metadata: {
              file_number: 'FN-XXXXXXX',
              jurisdiction: 'DOMESTIC',
              state: 'NY',
              labels: [],
              status: 'active',
            },
            id: 'e6806101-c0c9-4cbe-bfb5-ae6a36bf8d5c',
            type: 'registration',
          },
        ],
        city: 'Bronx',
        latitude: null,
        street_view_available: null,
        rating: {
          risk_rating: 'high',
          indicators: [
            {
              name: 'Valid US address',
              rating: 'negative',
              description: 'Invalid',
              type: 'valid_us_address',
              value: 'invalid',
            },
            {
              name: 'Deliverability',
              rating: 'positive',
              description: 'Deliverable',
              type: 'deliverability',
              value: 'deliverable',
            },
            {
              name: 'Geographical location',
              rating: 'negative',
              description: 'Unknown',
              type: 'geographical_location',
              value: 'unknown',
            },
            {
              name: 'Commercial registered agent',
              rating: 'neutral',
              description: 'Unknown',
              type: 'registered_agent',
              value: 'unknown',
            },
            {
              name: 'Private mailbox',
              rating: 'neutral',
              description: 'Unknown',
              type: 'private_mailbox',
              value: 'unknown',
            },
            {
              name: 'Location frequency',
              rating: 'positive',
              description: '1 business',
              type: 'location_frequency',
              value: '1_business',
            },
            {
              name: 'Property type',
              rating: 'neutral',
              description: 'Unknown',
              type: 'property_type',
              value: 'unknown',
            },
          ],
        },
        deliverable: true,
        created_at: '2026-02-20T17:30:04.584Z',
        full_address: '354 Circle Court,Bronx, NY 10468',
        address_line2: null,
        updated_at: '2026-02-20T17:30:04.584Z',
        address_line1: '354 Circle Ct',
        property_type: null,
        state: 'NY',
        id: '322aebff-0921-426e-9a49-8ba47f793185',
        longitude: null,
        location_count: 1,
        deliverability_analysis: null,
        registered_agent_name: null,
        labels: [],
        submitted: false,
        cmra: false,
        postal_code: '10468',
        business_id: 'df2690f4-b310-4e4e-b356-e4cde4ed8edb',
        object: 'address',
      },
    ],
    documents: [],
    fmcsa_registrations: [],
    adverse_media_screening: null,
    created_at: '2026-02-20T17:30:04.323Z',
    external_id: null,
    formation: {
      formation_date: '2020-02-24',
      entity_type: 'CORPORATION',
      updated_at: '2026-02-20T17:30:04.782Z',
      sources: [
        {
          metadata: {
            file_number: 'FN-XXXXXXX',
            jurisdiction: 'DOMESTIC',
            state: 'NY',
            status: 'active',
          },
          id: 'e6806101-c0c9-4cbe-bfb5-ae6a36bf8d5c',
          type: 'registration',
        },
      ],
      formation_state: 'NY',
      created_at: '2026-02-20T17:30:04.782Z',
    },
    subscription: null,
    industry_classification: null,
    updated_at: '2026-02-20T17:30:05.621Z',
    bankruptcies: [],
    review: {
      completed_at: null,
      updated_at: '2026-02-20T17:30:04.487Z',
      created_at: '2026-02-20T17:30:04.487Z',
      id: 'd8df6108-8601-4976-a3bd-d0de594c7907',
      assignee: {
        settings: {
          receives_agent_emails: false,
        },
        last_login_at: null,
        directory_managed: false,
        image_url:
          'https://www.gravatar.com/avatar/bd43e7168c81bb7fe5b439c8582d59e0?s=64&d=https%3A%2F%2Fapp-sandbox.middesk.com%2Fimages%2Fdefault-avatar.png',
        roles: ['admin', 'member'],
        name: 'Catherine Jiang',
        created_at: '2026-02-17T21:26:07.880Z',
        id: '43b518e0-8921-49c9-b94a-40dcd649020b',
        email: 'catherine@usedill.com',
        object: 'user',
      },
      tasks: [
        {
          sub_label: 'Unverified',
          sources: [],
          name: 'name',
          label: 'Business Name',
          category: 'name',
          message: 'Unable to identify a match to the submitted Business Name',
          key: 'name',
          status: 'failure',
        },
        {
          sub_label: 'High',
          sources: [],
          name: 'address',
          label: 'Address Risk',
          category: 'address',
          message: 'Address risk is high',
          key: 'address_risk',
          status: 'failure',
        },
        {
          sub_label: 'Not Issued',
          sources: [],
          name: 'tin',
          label: 'TIN Match',
          category: 'tin',
          message:
            'TIN has not been issued by the IRS. There is often a delay after formation for the IRS database to process TINs for new businesses.',
          key: 'tin_issued',
          status: 'failure',
        },
        {
          sub_label: 'Not Found',
          sources: [],
          name: 'tin',
          label: 'TIN Match',
          category: 'tin',
          message:
            'The IRS does not have a record for the submitted TIN and Business Name combination',
          key: 'tin',
          status: 'failure',
        },
        {
          sub_label: 'Registered Agent',
          sources: [],
          name: 'address',
          label: 'Office Address',
          category: 'address',
          message: 'Submitted Office Address is associated with a known Registered Agent',
          key: 'address_registered_agent',
          status: 'warning',
        },
        {
          sub_label: 'Verified',
          sources: [
            {
              metadata: {
                submitted: true,
                address_line2: null,
                city: 'New York',
                address_line1: '991 Registered Agent St',
                state: 'NY',
                full_address: '991 registered agent st., New York, NY 10013',
                postal_code: '10013',
              },
              id: 'e8d80114-95d0-44c3-8261-76c6d2a7519f',
              type: 'address',
            },
          ],
          name: 'address',
          label: 'Office Address',
          category: 'address',
          message: 'Match identified to the submitted Office Address',
          key: 'address_verification',
          status: 'success',
        },
        {
          sub_label: 'Deliverable',
          sources: [],
          name: 'address',
          label: 'Office Address',
          category: 'address',
          message: 'The USPS is able to deliver mail to the submitted Office Address',
          key: 'address_deliverability',
          status: 'success',
        },
        {
          sub_label: 'Commercial',
          sources: [],
          name: 'address',
          label: 'Office Address',
          category: 'address',
          message: 'Submitted Office Address is a Commercial property',
          key: 'address_property_type',
          status: 'success',
        },
        {
          sub_label: 'Low frequency',
          sources: [],
          name: 'address',
          label: 'Office Address',
          category: 'address',
          message: '1 business uses this location',
          key: 'location_frequency',
          status: 'success',
        },
        {
          sub_label: 'Submitted Active',
          sources: [],
          name: 'sos',
          label: 'SOS Filings',
          category: 'sos',
          message: 'The business is Active in the state of the submitted Office Address',
          key: 'sos_match',
          status: 'success',
        },
        {
          sub_label: 'Active',
          sources: [],
          name: 'sos',
          label: 'SOS Filings',
          category: 'sos',
          message: '2 of 2 filings are Active',
          key: 'sos_active',
          status: 'success',
        },
        {
          sub_label: 'Good Standing',
          sources: [],
          name: 'sos',
          label: 'SOS Domestic Sub‑status',
          category: 'sos',
          message: 'The domestic registration is in Good Standing.',
          key: 'sos_domestic_sub_status',
          status: 'success',
        },
        {
          sub_label: 'Domestic Active',
          sources: [],
          name: 'sos',
          label: 'SOS Filings',
          category: 'sos',
          message: 'Active domestic filing found',
          key: 'sos_domestic',
          status: 'success',
        },
        {
          sub_label: 'No Hits',
          sources: [],
          name: 'watchlist',
          label: 'Watchlist',
          category: 'watchlist',
          message: 'No Watchlist hits were identified',
          key: 'watchlist',
          status: 'success',
        },
        {
          sub_label: 'None Found',
          sources: [],
          name: 'bankruptcies',
          label: 'Bankruptcies',
          category: 'bankruptcies',
          message: 'The business has no bankruptcy filings',
          key: 'bankruptcies',
          status: 'success',
        },
      ],
      object: 'review',
    },
    tin: {
      verified_by: null,
      updated_at: '2026-02-20T17:30:04.649Z',
      mismatch: false,
      name: 'Unverified Name Business',
      verified: false,
      tin: '44-4555666',
      error: null,
      issued: false,
      business_id: 'df2690f4-b310-4e4e-b356-e4cde4ed8edb',
      unknown: true,
    },
    id: 'df2690f4-b310-4e4e-b356-e4cde4ed8edb',
    signal: null,
    supported_document_types: ['Articles of Incorporation', 'Certificate of Good Standing'],
    business_batch_id: null,
    assignee_id: '43b518e0-8921-49c9-b94a-40dcd649020b',
    requester: {
      name: 'Dill',
      id: 'f2b57db4-d781-471b-9b73-e878eb420f67',
      type: 'account',
      requested_at: '2026-02-20T17:30:04.342Z',
    },
    website: null,
    registrations: [
      {
        addresses: [
          '991 REGISTERED AGENT ST, NEW YORK, NY 10013',
          '354 CIRCLE COURT,BRONX, NY 10468',
        ],
        registered_agent: {},
        sub_status: 'GOOD_STANDING',
        jurisdiction: 'DOMESTIC',
        source: 'https://apps.dos.ny.gov/publicInquiry/',
        file_number: 'FN-XXXXXXX',
        entity_type: 'CORPORATION',
        registration_date: '2020-02-24',
        name: 'Middesk Inc',
        id: 'e6806101-c0c9-4cbe-bfb5-ae6a36bf8d5c',
        state: 'NY',
        business_id: 'df2690f4-b310-4e4e-b356-e4cde4ed8edb',
        status_details: 'Active-Good Standing',
        officers: [],
        object: 'registration',
        status: 'active',
      },
      {
        addresses: [
          '991 REGISTERED AGENT ST, NEW YORK, NY 10013',
          '354 CIRCLE COURT,BRONX, NY 10468',
        ],
        registered_agent: {},
        sub_status: null,
        jurisdiction: 'FOREIGN',
        source: 'https://www.sos.state.co.us/biz/BusinessEntityCriteriaExt.do',
        file_number: '12345135135',
        entity_type: 'CORPORATION',
        registration_date: '2020-02-24',
        name: 'Middesk Inc',
        id: '217af196-f96c-45a7-8027-b706fc4ebe1e',
        state: 'CO',
        business_id: 'df2690f4-b310-4e4e-b356-e4cde4ed8edb',
        status_details: null,
        officers: [],
        object: 'registration',
        status: 'active',
      },
    ],
    litigations: [],
    profiles: [],
    monitor: null,
    certifications: [],
    people: [],
    liens: [],
    tags: [],
    phone_numbers: [],
    names: [
      {
        submitted: true,
        sources: [],
        name: 'Unverified Name Business',
        id: '54043ab5-ccc4-43a6-82b8-29e0943d1ed1',
        type: 'legal',
        business_id: 'df2690f4-b310-4e4e-b356-e4cde4ed8edb',
        object: 'name',
      },
      {
        submitted: false,
        sources: [
          {
            metadata: {
              file_number: 'FN-XXXXXXX',
              jurisdiction: 'DOMESTIC',
              state: 'NY',
              status: 'active',
            },
            id: 'e6806101-c0c9-4cbe-bfb5-ae6a36bf8d5c',
            type: 'registration',
          },
        ],
        name: 'Middesk Inc',
        id: '18aa91a0-bd2d-42a5-a344-fe0985175766',
        type: null,
        business_id: 'df2690f4-b310-4e4e-b356-e4cde4ed8edb',
        object: 'name',
      },
    ],
    submitted: {
      email_addresses: null,
      addresses: [
        {
          city: 'New York',
          address_line1: '991 registered agent st.',
          state: 'NY',
          postal_code: '10013',
        },
      ],
      website: {},
      profiles: [],
      external_id: null,
      formation: null,
      people: [],
      tags: null,
      phone_numbers: [],
      entity_type: null,
      names: null,
      name: 'Unverified Name Business',
      tin: {
        tin: '444555666',
      },
      unique_external_id: null,
      orders: null,
      object: 'submitted_attributes',
      assignee_id: null,
    },
    politically_exposed_person_screening: null,
    policy_results: [],
    name: 'Unverified Name Business',
    unique_external_id: null,
    orders: [
      {
        requester: {
          name: 'Dill',
          type: 'account',
        },
        completed_at: '2026-02-20T17:30:05.099Z',
        product: 'business_verification_verify',
        package: 'business_verification_verify',
        updated_at: '2026-02-20T17:30:05.499Z',
        created_at: '2026-02-20T17:30:04.342Z',
        id: 'c087c1a9-77cb-4c7d-8c64-0ddf3aacd709',
        monitoring: false,
        business_id: 'df2690f4-b310-4e4e-b356-e4cde4ed8edb',
        subproducts: [],
        object: 'order',
        status: 'completed',
      },
      {
        requester: {
          name: 'Dill',
          type: 'account',
        },
        completed_at: '2026-02-20T17:30:05.401Z',
        product: 'bankruptcies',
        package: 'bankruptcies',
        updated_at: '2026-02-20T17:30:05.401Z',
        created_at: '2026-02-20T17:30:04.346Z',
        id: '2242b3f1-ed23-497d-a505-0361c38126fb',
        monitoring: false,
        business_id: 'df2690f4-b310-4e4e-b356-e4cde4ed8edb',
        subproducts: [],
        object: 'order',
        status: 'completed',
      },
    ],
    tax_exempt_organization: null,
    watchlist: {
      lists: [
        {
          agency: 'Office of Foreign Assets Control',
          organization: 'U.S. Department of Treasury',
          agency_abbr: 'OFAC',
          title: 'Capta List',
          abbr: 'CAP',
          results: [],
          object: 'watchlist_source',
        },
        {
          agency: 'Bureau of Industry and Security',
          organization: 'U.S. Department of Commerce',
          agency_abbr: 'BIS',
          title: 'Denied Persons List',
          abbr: 'DPL',
          results: [],
          object: 'watchlist_source',
        },
        {
          agency: 'Directorate of Defense Trade Controls',
          organization: 'U.S. Department of State',
          agency_abbr: 'DDTC',
          title: 'AECA/ITAR Debarred',
          abbr: 'DTC',
          results: [],
          object: 'watchlist_source',
        },
        {
          agency: 'Bureau of Industry and Security',
          organization: 'U.S. Department of Commerce',
          agency_abbr: 'BIS',
          title: 'Entity List',
          abbr: 'EL',
          results: [],
          object: 'watchlist_source',
        },
        {
          agency: 'Office of Foreign Assets Control',
          organization: 'U.S. Department of Treasury',
          agency_abbr: 'OFAC',
          title: 'Foreign Sanctions Evaders',
          abbr: 'FSE',
          results: [],
          object: 'watchlist_source',
        },
        {
          agency: 'Bureau of International Security and Non-Proliferation',
          organization: 'U.S. Department of State',
          agency_abbr: 'ISN',
          title: 'Nonproliferation Sanctions',
          abbr: 'ISN',
          results: [],
          object: 'watchlist_source',
        },
        {
          agency: 'Bureau of Industry and Security',
          organization: 'U.S. Department of Commerce',
          agency_abbr: 'BIS',
          title: 'Military End User',
          abbr: 'MEU',
          results: [],
          object: 'watchlist_source',
        },
        {
          agency: 'Office of Foreign Assets Control',
          organization: 'U.S. Department of Treasury',
          agency_abbr: 'OFAC',
          title: 'Non-SDN Chinese Military-Industrial Complex Companies List',
          abbr: 'NS-CMIC',
          results: [],
          object: 'watchlist_source',
        },
        {
          agency: 'Office of Foreign Assets Control',
          organization: 'U.S. Department of Treasury',
          agency_abbr: 'OFAC',
          title: 'Non-SDN Iranian Sanctions',
          abbr: 'NS-ISA',
          results: [],
          object: 'watchlist_source',
        },
        {
          agency: 'Office of Foreign Assets Control',
          organization: 'U.S. Department of Treasury',
          agency_abbr: 'OFAC',
          title: 'Non-SDN Menu-Based Sanctions',
          abbr: 'NS-MBS',
          results: [],
          object: 'watchlist_source',
        },
        {
          agency: 'Office of Foreign Assets Control',
          organization: 'U.S. Department of Treasury',
          agency_abbr: 'OFAC',
          title: 'Palestinian Legislative Council',
          abbr: 'PLC',
          results: [],
          object: 'watchlist_source',
        },
        {
          agency: 'Office of Foreign Assets Control',
          organization: 'U.S. Department of Treasury',
          agency_abbr: 'OFAC',
          title: 'Specially Designated Nationals',
          abbr: 'SDN',
          results: [],
          object: 'watchlist_source',
        },
        {
          agency: 'Office of Foreign Assets Control',
          organization: 'U.S. Department of Treasury',
          agency_abbr: 'OFAC',
          title: 'Sectoral Sanctions Identifications',
          abbr: 'SSI',
          results: [],
          object: 'watchlist_source',
        },
        {
          agency: 'Bureau of Industry and Security',
          organization: 'U.S. Department of Commerce',
          agency_abbr: 'BIS',
          title: 'Unverified List',
          abbr: 'UVL',
          results: [],
          object: 'watchlist_source',
        },
      ],
      agencies: [
        {
          org: 'U.S. Department of Treasury',
          name: 'Office of Foreign Assets Control',
          abbr: 'OFAC',
        },
        {
          org: 'U.S. Department of Commerce',
          name: 'Bureau of Industry and Security',
          abbr: 'BIS',
        },
        {
          org: 'U.S. Department of State',
          name: 'Directorate of Defense Trade Controls',
          abbr: 'DDTC',
        },
        {
          org: 'U.S. Department of State',
          name: 'Bureau of International Security and Non-Proliferation',
          abbr: 'ISN',
        },
      ],
      id: '9619555d-83ad-41c7-b078-1f1a8ff82b6f',
      hit_count: 0,
      people: [],
      object: 'watchlist',
    },
    object: 'business',
    status: 'in_review',
  },
  {
    object: 'business',
    id: '3588d1a0-34f4-4197-b1e9-74750377edb9',
    external_id: null,
    unique_external_id: null,
    name: 'LLC',
    created_at: '2026-02-23T16:45:52.680Z',
    updated_at: '2026-02-23T16:45:54.191Z',
    status: 'in_review',
    tags: [],
    requester: {
      id: 'f2b57db4-d781-471b-9b73-e878eb420f67',
      type: 'account',
      name: 'Dill',
      requested_at: '2026-02-23T16:45:52.698Z',
    },
    assignee_id: '43b518e0-8921-49c9-b94a-40dcd649020b',
    supported_document_types: ['Articles of Incorporation', 'Certificate of Good Standing'],
    review: {
      object: 'review',
      id: '3ec85476-f5d9-4e5d-aa35-db04beb46603',
      created_at: '2026-02-23T16:45:52.862Z',
      updated_at: '2026-02-23T16:45:52.862Z',
      completed_at: null,
      tasks: [
        {
          category: 'name',
          key: 'name',
          label: 'Business Name',
          message: 'Match identified to the submitted Business Name',
          name: 'name',
          status: 'success',
          sub_label: 'Verified',
          sources: [
            {
              id: '9a3e2d7d-4b55-4b7c-8067-184cd530ef07',
              type: 'name',
              metadata: {
                name: '00-0000000',
                submitted: true,
              },
            },
          ],
        },
        {
          category: 'address',
          key: 'address_verification',
          label: 'Office Address',
          message: 'Match identified to the submitted Office Address',
          name: 'address',
          status: 'success',
          sub_label: 'Verified',
          sources: [
            {
              id: '511544d2-9c6d-4d58-8274-4bbae37caa69',
              type: 'address',
              metadata: {
                city: 'Nairobi',
                state: 'LA',
                submitted: true,
                postal_code: '32452',
                full_address: 'Neema Avenue, Nairobi, LA 32452',
                address_line1: 'Neema Avenue',
                address_line2: null,
              },
            },
          ],
        },
        {
          category: 'address',
          key: 'address_deliverability',
          label: 'Office Address',
          message: 'The USPS is able to deliver mail to the submitted Office Address',
          name: 'address',
          status: 'success',
          sub_label: 'Deliverable',
          sources: [],
        },
        {
          category: 'address',
          key: 'address_property_type',
          label: 'Office Address',
          message: 'Submitted Office Address is a Commercial property',
          name: 'address',
          status: 'success',
          sub_label: 'Commercial',
          sources: [],
        },
        {
          category: 'address',
          key: 'location_frequency',
          label: 'Office Address',
          message: '1 business uses this location',
          name: 'address',
          status: 'success',
          sub_label: 'Low frequency',
          sources: [],
        },
        {
          category: 'address',
          key: 'address_risk',
          label: 'Address Risk',
          message: 'Address risk is low',
          name: 'address',
          status: 'success',
          sub_label: 'Low',
          sources: [],
        },
        {
          category: 'sos',
          key: 'sos_match',
          label: 'SOS Filings',
          message: 'The business is Active in the state of the submitted Office Address',
          name: 'sos',
          status: 'success',
          sub_label: 'Submitted Active',
          sources: [],
        },
        {
          category: 'sos',
          key: 'sos_active',
          label: 'SOS Filings',
          message: '2 of 2 filings are Active',
          name: 'sos',
          status: 'success',
          sub_label: 'Active',
          sources: [],
        },
        {
          category: 'sos',
          key: 'sos_domestic_sub_status',
          label: 'SOS Domestic Sub‑status',
          message: 'The domestic registration is in Good Standing.',
          name: 'sos',
          status: 'success',
          sub_label: 'Good Standing',
          sources: [],
        },
        {
          category: 'sos',
          key: 'sos_domestic',
          label: 'SOS Filings',
          message: 'Active domestic filing found',
          name: 'sos',
          status: 'success',
          sub_label: 'Domestic Active',
          sources: [],
        },
        {
          category: 'watchlist',
          key: 'watchlist',
          label: 'Watchlist',
          message: 'No Watchlist hits were identified',
          name: 'watchlist',
          status: 'success',
          sub_label: 'No Hits',
          sources: [],
        },
        {
          category: 'bankruptcies',
          key: 'bankruptcies',
          label: 'Bankruptcies',
          message: 'The business has no bankruptcy filings',
          name: 'bankruptcies',
          status: 'success',
          sub_label: 'None Found',
          sources: [],
        },
      ],
      assignee: {
        object: 'user',
        id: '43b518e0-8921-49c9-b94a-40dcd649020b',
        name: 'Catherine Jiang',
        email: 'catherine@usedill.com',
        roles: ['admin', 'member'],
        image_url:
          'https://www.gravatar.com/avatar/bd43e7168c81bb7fe5b439c8582d59e0?s=64&d=https%3A%2F%2Fapp-sandbox.middesk.com%2Fimages%2Fdefault-avatar.png',
        directory_managed: false,
        last_login_at: null,
        settings: {
          receives_agent_emails: false,
        },
        created_at: '2026-02-17T21:26:07.880Z',
      },
    },
    business_batch_id: null,
    formation: {
      entity_type: 'CORPORATION',
      formation_date: '2020-02-24',
      formation_state: 'LA',
      created_at: '2026-02-23T16:45:53.234Z',
      updated_at: '2026-02-23T16:45:53.234Z',
      sources: [
        {
          id: '2845408e-31df-465a-b07f-2b825371fbe5',
          type: 'registration',
          metadata: {
            state: 'LA',
            status: 'active',
            file_number: 'FN-XXXXXXX',
            jurisdiction: 'DOMESTIC',
          },
        },
      ],
    },
    website: null,
    watchlist: {
      object: 'watchlist',
      id: 'ae79c75f-f526-4b6d-984c-0740b072450b',
      hit_count: 0,
      agencies: [
        {
          abbr: 'OFAC',
          name: 'Office of Foreign Assets Control',
          org: 'U.S. Department of Treasury',
        },
        {
          abbr: 'BIS',
          name: 'Bureau of Industry and Security',
          org: 'U.S. Department of Commerce',
        },
        {
          abbr: 'DDTC',
          name: 'Directorate of Defense Trade Controls',
          org: 'U.S. Department of State',
        },
        {
          abbr: 'ISN',
          name: 'Bureau of International Security and Non-Proliferation',
          org: 'U.S. Department of State',
        },
      ],
      lists: [
        {
          object: 'watchlist_source',
          agency: 'Office of Foreign Assets Control',
          agency_abbr: 'OFAC',
          organization: 'U.S. Department of Treasury',
          title: 'Capta List',
          abbr: 'CAP',
          results: [],
        },
        {
          object: 'watchlist_source',
          agency: 'Bureau of Industry and Security',
          agency_abbr: 'BIS',
          organization: 'U.S. Department of Commerce',
          title: 'Denied Persons List',
          abbr: 'DPL',
          results: [],
        },
        {
          object: 'watchlist_source',
          agency: 'Directorate of Defense Trade Controls',
          agency_abbr: 'DDTC',
          organization: 'U.S. Department of State',
          title: 'AECA/ITAR Debarred',
          abbr: 'DTC',
          results: [],
        },
        {
          object: 'watchlist_source',
          agency: 'Bureau of Industry and Security',
          agency_abbr: 'BIS',
          organization: 'U.S. Department of Commerce',
          title: 'Entity List',
          abbr: 'EL',
          results: [],
        },
        {
          object: 'watchlist_source',
          agency: 'Office of Foreign Assets Control',
          agency_abbr: 'OFAC',
          organization: 'U.S. Department of Treasury',
          title: 'Foreign Sanctions Evaders',
          abbr: 'FSE',
          results: [],
        },
        {
          object: 'watchlist_source',
          agency: 'Bureau of International Security and Non-Proliferation',
          agency_abbr: 'ISN',
          organization: 'U.S. Department of State',
          title: 'Nonproliferation Sanctions',
          abbr: 'ISN',
          results: [],
        },
        {
          object: 'watchlist_source',
          agency: 'Bureau of Industry and Security',
          agency_abbr: 'BIS',
          organization: 'U.S. Department of Commerce',
          title: 'Military End User',
          abbr: 'MEU',
          results: [],
        },
        {
          object: 'watchlist_source',
          agency: 'Office of Foreign Assets Control',
          agency_abbr: 'OFAC',
          organization: 'U.S. Department of Treasury',
          title: 'Non-SDN Chinese Military-Industrial Complex Companies List',
          abbr: 'NS-CMIC',
          results: [],
        },
        {
          object: 'watchlist_source',
          agency: 'Office of Foreign Assets Control',
          agency_abbr: 'OFAC',
          organization: 'U.S. Department of Treasury',
          title: 'Non-SDN Iranian Sanctions',
          abbr: 'NS-ISA',
          results: [],
        },
        {
          object: 'watchlist_source',
          agency: 'Office of Foreign Assets Control',
          agency_abbr: 'OFAC',
          organization: 'U.S. Department of Treasury',
          title: 'Non-SDN Menu-Based Sanctions',
          abbr: 'NS-MBS',
          results: [],
        },
        {
          object: 'watchlist_source',
          agency: 'Office of Foreign Assets Control',
          agency_abbr: 'OFAC',
          organization: 'U.S. Department of Treasury',
          title: 'Palestinian Legislative Council',
          abbr: 'PLC',
          results: [],
        },
        {
          object: 'watchlist_source',
          agency: 'Office of Foreign Assets Control',
          agency_abbr: 'OFAC',
          organization: 'U.S. Department of Treasury',
          title: 'Specially Designated Nationals',
          abbr: 'SDN',
          results: [],
        },
        {
          object: 'watchlist_source',
          agency: 'Office of Foreign Assets Control',
          agency_abbr: 'OFAC',
          organization: 'U.S. Department of Treasury',
          title: 'Sectoral Sanctions Identifications',
          abbr: 'SSI',
          results: [],
        },
        {
          object: 'watchlist_source',
          agency: 'Bureau of Industry and Security',
          agency_abbr: 'BIS',
          organization: 'U.S. Department of Commerce',
          title: 'Unverified List',
          abbr: 'UVL',
          results: [],
        },
      ],
      people: [],
    },
    bankruptcies: [],
    certifications: [],
    documents: [],
    liens: [],
    names: [
      {
        object: 'name',
        id: '9a3e2d7d-4b55-4b7c-8067-184cd530ef07',
        name: '00-0000000',
        submitted: true,
        type: 'legal',
        business_id: '3588d1a0-34f4-4197-b1e9-74750377edb9',
        sources: [
          {
            id: '2845408e-31df-465a-b07f-2b825371fbe5',
            type: 'registration',
            metadata: {
              state: 'LA',
              status: 'active',
              file_number: 'FN-XXXXXXX',
              jurisdiction: 'DOMESTIC',
            },
          },
        ],
      },
    ],
    addresses: [
      {
        object: 'address',
        address_line1: 'Neema Avenue',
        address_line2: null,
        city: 'Nairobi',
        state: 'LA',
        postal_code: '32452',
        full_address: 'Neema Avenue, Nairobi, LA 32452',
        submitted: true,
        id: '511544d2-9c6d-4d58-8274-4bbae37caa69',
        latitude: 40.52,
        longitude: 30.4,
        property_type: null,
        deliverable: true,
        deliverability_analysis: null,
        street_view_available: false,
        labels: [],
        created_at: '2026-02-23T16:45:52.692Z',
        updated_at: '2026-02-23T16:45:52.943Z',
        registered_agent_name: null,
        cmra: false,
        business_id: '3588d1a0-34f4-4197-b1e9-74750377edb9',
        location_count: 1,
        is_registered_agent: false,
        sources: [
          {
            id: '2845408e-31df-465a-b07f-2b825371fbe5',
            type: 'registration',
            metadata: {
              state: 'LA',
              labels: [],
              status: 'active',
              file_number: 'FN-XXXXXXX',
              jurisdiction: 'DOMESTIC',
            },
          },
        ],
        rating: {
          indicators: [
            {
              type: 'valid_us_address',
              name: 'Valid US address',
              rating: 'positive',
              value: 'valid',
              description: 'Valid',
            },
            {
              type: 'deliverability',
              name: 'Deliverability',
              rating: 'positive',
              value: 'deliverable',
              description: 'Deliverable',
            },
            {
              type: 'geographical_location',
              name: 'Geographical location',
              rating: 'positive',
              value: 'us',
              description: 'US',
            },
            {
              type: 'registered_agent',
              name: 'Commercial registered agent',
              rating: 'positive',
              value: 'not_registered_agent',
              description: 'Not a commercial registered agent',
            },
            {
              type: 'private_mailbox',
              name: 'Private mailbox',
              rating: 'positive',
              value: 'not_private_mailbox',
              description: 'Not a private mailbox',
            },
            {
              type: 'location_frequency',
              name: 'Location frequency',
              rating: 'positive',
              value: '1_business',
              description: '1 business',
            },
            {
              type: 'virtual_address',
              name: 'Virtual address',
              rating: 'positive',
              value: 'not_virtual_address',
              description: 'Not a virtual address',
            },
          ],
          risk_rating: 'low',
        },
      },
      {
        object: 'address',
        address_line1: '354 Circle Ct',
        address_line2: null,
        city: 'Bronx',
        state: 'NY',
        postal_code: '10468',
        full_address: '354 Circle Court,Bronx, NY 10468',
        submitted: false,
        id: 'e326853f-c570-4d86-9920-d42d1001c8e1',
        latitude: null,
        longitude: null,
        property_type: null,
        deliverable: true,
        deliverability_analysis: null,
        street_view_available: null,
        labels: [],
        created_at: '2026-02-23T16:45:52.969Z',
        updated_at: '2026-02-23T16:45:52.969Z',
        registered_agent_name: null,
        cmra: false,
        business_id: '3588d1a0-34f4-4197-b1e9-74750377edb9',
        location_count: 1,
        is_registered_agent: false,
        sources: [
          {
            id: '2845408e-31df-465a-b07f-2b825371fbe5',
            type: 'registration',
            metadata: {
              state: 'LA',
              labels: [],
              status: 'active',
              file_number: 'FN-XXXXXXX',
              jurisdiction: 'DOMESTIC',
            },
          },
        ],
        rating: {
          indicators: [
            {
              type: 'valid_us_address',
              name: 'Valid US address',
              rating: 'negative',
              value: 'invalid',
              description: 'Invalid',
            },
            {
              type: 'deliverability',
              name: 'Deliverability',
              rating: 'positive',
              value: 'deliverable',
              description: 'Deliverable',
            },
            {
              type: 'geographical_location',
              name: 'Geographical location',
              rating: 'negative',
              value: 'unknown',
              description: 'Unknown',
            },
            {
              type: 'registered_agent',
              name: 'Commercial registered agent',
              rating: 'neutral',
              value: 'unknown',
              description: 'Unknown',
            },
            {
              type: 'private_mailbox',
              name: 'Private mailbox',
              rating: 'neutral',
              value: 'unknown',
              description: 'Unknown',
            },
            {
              type: 'location_frequency',
              name: 'Location frequency',
              rating: 'positive',
              value: '1_business',
              description: '1 business',
            },
            {
              type: 'property_type',
              name: 'Property type',
              rating: 'neutral',
              value: 'unknown',
              description: 'Unknown',
            },
          ],
          risk_rating: 'high',
        },
      },
    ],
    people: [],
    phone_numbers: [],
    profiles: [],
    registrations: [
      {
        object: 'registration',
        id: '2845408e-31df-465a-b07f-2b825371fbe5',
        business_id: '3588d1a0-34f4-4197-b1e9-74750377edb9',
        name: '00-0000000',
        status: 'active',
        sub_status: 'GOOD_STANDING',
        status_details: 'Active-Good Standing',
        jurisdiction: 'DOMESTIC',
        entity_type: 'CORPORATION',
        file_number: 'FN-XXXXXXX',
        addresses: ['NEEMA AVENUE, NAIROBI, LA 32452', '354 CIRCLE COURT,BRONX, NY 10468'],
        officers: [],
        registered_agent: {},
        registration_date: '2020-02-24',
        state: 'LA',
        source: 'https://coraweb.sos.la.gov/CommercialSearch/CommercialSearch.aspx',
      },
      {
        object: 'registration',
        id: 'ef597617-79cf-4f2e-9ccd-36cff24f2cf7',
        business_id: '3588d1a0-34f4-4197-b1e9-74750377edb9',
        name: '00-0000000',
        status: 'active',
        sub_status: null,
        status_details: null,
        jurisdiction: 'FOREIGN',
        entity_type: 'CORPORATION',
        file_number: '12345135135',
        addresses: ['NEEMA AVENUE, NAIROBI, LA 32452', '354 CIRCLE COURT,BRONX, NY 10468'],
        officers: [],
        registered_agent: {},
        registration_date: '2020-02-24',
        state: 'CO',
        source: 'https://www.sos.state.co.us/biz/BusinessEntityCriteriaExt.do',
      },
    ],
    orders: [
      {
        object: 'order',
        id: 'bf66a7ab-50b7-4be0-825e-8d2a88329b75',
        business_id: '3588d1a0-34f4-4197-b1e9-74750377edb9',
        completed_at: '2026-02-23T16:45:53.593Z',
        created_at: '2026-02-23T16:45:52.698Z',
        monitoring: false,
        product: 'business_verification_verify',
        package: 'business_verification_verify',
        requester: {
          name: 'Dill',
          type: 'account',
        },
        status: 'completed',
        subproducts: [],
        updated_at: '2026-02-23T16:45:54.050Z',
      },
      {
        object: 'order',
        id: 'b884b3d5-ee6d-4c0b-92bd-38c4b7a9c045',
        business_id: '3588d1a0-34f4-4197-b1e9-74750377edb9',
        completed_at: '2026-02-23T16:45:53.940Z',
        created_at: '2026-02-23T16:45:52.701Z',
        monitoring: false,
        product: 'bankruptcies',
        package: 'bankruptcies',
        requester: {
          name: 'Dill',
          type: 'account',
        },
        status: 'completed',
        subproducts: [],
        updated_at: '2026-02-23T16:45:54.237Z',
      },
    ],
    industry_classification: null,
    monitor: null,
    tax_exempt_organization: null,
    fmcsa_registrations: [],
    litigations: [],
    policy_results: [],
    politically_exposed_person_screening: null,
    adverse_media_screening: null,
    signal: null,
    submitted: {
      object: 'submitted_attributes',
      name: 'LLC',
      entity_type: null,
      addresses: [
        {
          city: 'Nairobi',
          state: 'LA',
          postal_code: '32452',
          address_line1: 'Neema Avenue',
        },
      ],
      orders: null,
      people: [],
      phone_numbers: [],
      email_addresses: null,
      tags: null,
      external_id: null,
      unique_external_id: null,
      website: {},
      assignee_id: null,
      formation: null,
      names: null,
      profiles: [],
    },
    subscription: null,
  },
];

const mapTask = (tasks: any[], key: string, extraCondition?: (task: any) => boolean) => {
  const task = tasks.find((t) => t.key === key && (!extraCondition || extraCondition(t)));

  return task
    ? {
        message: task.message,
        status: task.status,
        label: task.sub_label,
      }
    : null;
};

export const getSampleTin = (tinEin: string, name: string) => {
  const found = mideskData.find(
    (d) => d?.submitted?.tin?.tin.replaceAll('-', '').trim() === tinEin.replaceAll('-', '').trim()
  );
  if (found) {
    const tin = {
      name: found.tin?.name,
      tin: found?.tin?.tin,
    };

    const tasks = found.review?.tasks ?? [];

    const tinMatch = mapTask(tasks, 'tin', (t) => t.label === 'TIN Match');

    return {
      tinMatch,
      tin,
    };
  }
  return {
    tin: {
      name: name,
      tin: tinEin,
    },
    tinMatch: {
      message: 'The IRS has a record for the submitted TIN and Business Name combination',
      status: 'success',
      label: 'Found',
    },
  };
};

export const getSamplSOS = (
  name: string,
  { address, city, state, zip }: { address?: string; city?: string; state?: string; zip?: string }
) => {
  const found = mideskData.find((d) =>
    name.toLowerCase().includes(d?.submitted?.name.toLowerCase())
  );
  const addressSOS = `${address ? address + ', ' : ''} ${city ? city + ', ' : ''} ${
    state ? state + ', ' : ''
  } ${zip}`.trim();
  if (found) {
    const registration = (found.registrations ?? []).map((reg: any, index: number) => ({
      addresses: addressSOS && index === 0 ? [addressSOS] : reg.addresses ?? [],
      entityType: capitalizeWordsInSentence(reg.entity_type ?? ''),
      fileNumber: reg.file_number,
      jurisdiction: reg.jurisdiction ? capitalizeWordsInSentence(reg.jurisdiction) : '',
      name: name,
      object: reg.object,
      officers: reg.officers,
      registeredAgent: reg.registered_agent,
      registrationDate: reg.registration_date,
      source: reg.source,
      state: state && index === 0 ? getStateName(state) : reg.state ? getStateName(reg.state) : '',
      status: reg.status,
      statusDetails: reg.status_details ?? '-',
      subStatus: reg.sub_status ? capitalizeWordsInSentence(reg.sub_status.replace('_', ' ')) : '-',
    }));
    const tasks = found.review?.tasks ?? [];

    const sosMatch = mapTask(tasks, 'sos_match');
    const nameMatch = mapTask(tasks, 'name');

    return {
      registration,
      sosMatch,
      nameMatch,
    };
  } else {
    const lastMiddeskItem = mideskData[mideskData.length - 1];
    const registration = (lastMiddeskItem.registrations ?? []).map((reg: any, index: number) => ({
      addresses: addressSOS && index === 0 ? [addressSOS] : reg.addresses ?? [],
      entityType: capitalizeWordsInSentence(reg.entity_type ?? ''),
      fileNumber: reg.file_number,
      jurisdiction: reg.jurisdiction ? capitalizeWordsInSentence(reg.jurisdiction) : '',
      name: name,
      object: reg.object,
      officers: reg.officers,
      registeredAgent: reg.registered_agent,
      registrationDate: reg.registration_date,
      source: reg.source,
      state: state && index === 0 ? getStateName(state) : reg.state ? getStateName(reg.state) : '',
      status: reg.status,
      statusDetails: reg.status_details ?? '-',
      subStatus: reg.sub_status ? capitalizeWordsInSentence(reg.sub_status.replace('_', ' ')) : '-',
    }));
    const tasks = lastMiddeskItem.review?.tasks ?? [];

    const sosMatch = mapTask(tasks, 'sos_match');
    const nameMatch = mapTask(tasks, 'name');

    return {
      registration,
      sosMatch,
      nameMatch,
    };
  }
};
